import React, { useState, useEffect, useCallback } from 'react';
import Sidebar from '../../components/Sidebar';
import ProfileDropdown from '../../components/ProfileDropdown';
import ProgressReportCard from '../../components/ProgressReportCard';
import axios from 'axios';
import API_BASE from '../../utils/api';

const API = API_BASE;

const TeacherProgressReports = () => {
  const [classInfo, setClassInfo] = useState(null);
  const [students, setStudents] = useState([]);
  const [selectedStudent, setSelectedStudent] = useState('');

  const token = localStorage.getItem('token');
  const headers = { Authorization: `Bearer ${token}` };

  const fetchClass = useCallback(async () => {
    try {
      const res = await axios.get(`${API}/classes/my-class`, { headers });
      setClassInfo(res.data);
      const studentsRes = await axios.get(`${API}/classes/${res.data._id}/students`, { headers });
      setStudents(studentsRes.data);
    } catch (err) {
      console.error('No class assigned:', err);
    }
  }, []);

  useEffect(() => { fetchClass(); }, [fetchClass]);

  return (
    <div className="flex h-screen bg-gray-50">
      <Sidebar />
      <div className="flex-1 overflow-auto">
        <div className="p-6">
          <div className="flex justify-between items-center mb-6">
            <div>
              <h1 className="text-3xl font-bold text-gray-800">📈 Progress Reports</h1>
              <p className="text-gray-500 mt-1">
                {classInfo ? `${classInfo.className} - ${classInfo.section}` : 'No class assigned'}
              </p>
            </div>
            <ProfileDropdown />
          </div>

          <div className="bg-white rounded-xl shadow-lg p-6 mb-6 max-w-md">
            <label className="block text-sm font-medium text-gray-700 mb-1">Student</label>
            <select value={selectedStudent} onChange={(e) => setSelectedStudent(e.target.value)}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500">
              <option value="">Select a student</option>
              {students.map((s) => (
                <option key={s._id} value={s._id}>{s.name} (Roll {s.rollNumber})</option>
              ))}
            </select>
          </div>

          {selectedStudent && <ProgressReportCard studentId={selectedStudent} editable accentColor="indigo" />}
        </div>
      </div>
    </div>
  );
};

export default TeacherProgressReports;
